/** Convert the API's PostgreSQL decimal-string projection into a UI number. */
export function parseApiDecimal(value: string): number {
  if (!/^\d+(?:\.\d+)?$/.test(value)) {
    throw new TypeError(`Invalid API decimal: ${value}`);
  }

  const parsed = Number(value);

  if (!Number.isFinite(parsed)) {
    throw new TypeError(`Invalid API decimal: ${value}`);
  }

  return parsed;
}
